import { View, ViewType } from "@common/types/views/views";

export enum HistoryFinancialAccountDetailsColumn {
    DATE = "date",
    ACCOUNT_NAME = "accountName",
    OLD_VALUE = "oldValue",
    NEW_VALUE = "newValue",
}

export interface HistoryFinancialAccountDetailsView extends View {
    type: ViewType.HISTORY_FINANCIAL_ACCOUNT;
    columns: Array<{ id: HistoryFinancialAccountDetailsColumn; options?: any }>;
}
